import { Controller } from "react-hook-form";
import { lang } from "../../Utils/lang";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import PasswordStrengthMeter from "../Reusable/PasswordStrengthMeter";

export default function UserData(props: any) {
  const { control } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickShowPassword = () =>
    setShowPassword((prev: boolean) => !prev);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev: boolean) => !prev);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => event.preventDefault();

  return (
    <>
      <Controller
        name="companyName"
        defaultValue=""
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="companyName"
            label={lang.organization}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="email"
        defaultValue=""
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="email"
            label={lang.email}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="phoneNumber"
        defaultValue=""
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="phoneNumber"
            label={lang.phoneNumber}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="password"
        defaultValue=""
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <TextField
              onChange={onChange}
              fullWidth
              style={{
                marginBottom: 4,
              }}
              value={value}
              error={!!error}
              helperText={error?.message}
              id="password"
              label={lang.password}
              size="small"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <PasswordStrengthMeter password={value} />
          </>
        )}
      />
      <Controller
        name="confirmPassword"
        defaultValue=""
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="confirmPassword"
            label={lang.confirmPassword}
            size="small"
            variant="outlined"
            type={showConfirmPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowConfirmPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </>
  );
}
